module.exports = __webpack_public_path__ + "img/1 (27).b8565a7e.png";